export default "__VITE_ASSET__Cn1hNx7f__"